export default __webpack_public_path__ + "static/media/photocv.13a58908.png";